import { twMerge } from '@shared/themes';
import type { ComponentProps, ReactNode } from 'react';
import { BackChevron } from '../BackChevron/BackChevron';

type SecondaryHeaderProps = ComponentProps<'div'> & {
  title: string;
  extraInfo?: ReactNode;
  backFallbackUrl?: string;
  /** Trailing slot: stacked below the title under xl, right-aligned on the same row at xl+. */
  actions?: ReactNode;
};

function SecondaryHeader({ children, title, className, extraInfo, backFallbackUrl, actions, ...props }: SecondaryHeaderProps) {
  const titleContent = (
    <>
      <BackChevron fallbackUrl={backFallbackUrl} headerVariant="subheader" variant="ghost" />
      <h1 className="heading-5" data-track-name={`${title}`}>
        {title}
      </h1>
      {extraInfo}
    </>
  );

  return (
    <div className={twMerge('ll-grid-container', className)} {...props}>
      {title &&
        (actions ? (
          <div className="ll-container-inner flex w-full flex-col xl:flex-row xl:items-center xl:justify-between" data-testid="secondary-header-row">
            <div className="flex items-center gap-2 mb-4 xl:mb-0" data-testid="secondary-header-title-slot">
              {titleContent}
            </div>
            <div className="w-full pt-2 xl:ml-auto xl:w-auto xl:pt-0" data-testid="secondary-header-actions-slot">
              {actions}
            </div>
          </div>
        ) : (
          <div className="flex items-center gap-2 ll-container-inner">{titleContent}</div>
        ))}
      {children}
    </div>
  );
}

export { SecondaryHeader };
